
import { mapGetters } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AddDevice extends Vue {
  public device = false;
  public uid = '';
  public unsubscribe = this.$store.subscribeAction((action, state) => {
    if (action.type === 'addDevice') {
      this.showDialog();
    }
  });

  public showDialog() {
    this.device = true;
  }

  public mounted() {
    console.log('AddDevice: mounted()');
    // this.device = true;
  }

  public beforeDestroy() {
    this.unsubscribe();
  }
}
